var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4993 0.749383C12.714 0.176312 11.6483 0.176312 10.863 0.749383L1.37955 7.66976C0.131056 8.58082 0.775478 10.5572 2.32105 10.5572H2.59782V17.9681C1.46006 18.5498 0.681152 19.7334 0.681152 21.0988V23.0155C0.681152 23.5447 1.11022 23.9738 1.63949 23.9738H22.7228C23.2521 23.9738 23.6812 23.5447 23.6812 23.0155V21.0988C23.6812 19.7334 22.9022 18.5498 21.7645 17.9681V10.5572H22.0413C23.5869 10.5572 24.2312 8.58083 22.9827 7.66976L13.4993 0.749383ZM11.9928 2.29764C12.105 2.21577 12.2573 2.21577 12.3695 2.29764L21.0616 8.64054H3.30074L11.9928 2.29764ZM19.8478 10.5572V17.5849H17.2923V10.5572H19.8478ZM15.3756 10.5572V17.5849H13.1395V10.5572H15.3756ZM11.2228 10.5572V17.5849H8.98671V10.5572H11.2228ZM4.19504 19.5016H20.1673C21.0494 19.5016 21.7645 20.2168 21.7645 21.0988V22.0572H2.59782V21.0988C2.59782 20.2168 3.31291 19.5016 4.19504 19.5016ZM4.51449 17.5849V10.5572H7.07004V17.5849H4.51449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIconSvg);
export default __webpack_public_path__ + "static/media/billingIconSvg.c3610b562ea03aa6fde647c0427808cf.svg";
export { ForwardRef as ReactComponent };